// breadcrumbsModule
window.breadcrumbsModule = (() => {
  function breadcrumbsUiHandling() {
    document.addEventListener("DOMContentLoaded", () => {
      const navigation = document.querySelector(
        ".shopify-block.shopify-app-block nav.breadcrumbs"
      );
      const closestAppSection = navigation.closest(".app-section");

      // Reset all styles
      // Set parent paddings
      // Adjust padding depeding if we are in collection page or product page
      const style = document.createElement("style");
      style.id = "breadcrumbs-styles";
      style.innerHTML += `
      .breadcrumbs__back-navigation{
        display:flex;
        margin-right: -8px;
        align-items: center;
        flex-shrink:0;
      }
      .breadcrumbs__back-navigation .breadcrumbs__back-navigation-seperator:empty {
        display:block;
      } 
      .breadcrumbs__back-navigation .breadcrumbs__back-navigation-seperator {
        width: 1px;
        height: 16px;
        background: var(--greyscale-Light-Grey, #C0BEBE);
        margin-right: 16px;
        margin-left: 16px;
      }
      .breadcrumbs {
        letter-spacing: 0;
        overflow-x: hidden;
        display:flex;
        gap:8px;
        align-items: center;
        padding-inline: 24px;
      }
      /* Customize the scrollbar */
      .breadcrumbs::-webkit-scrollbar {
          width: 4px;  /* Width of the vertical scrollbar */
          height: 4px; /* Height of the horizontal scrollbar */
      }
      
      /* Customize the scrollbar thumb */
      .breadcrumbs::-webkit-scrollbar-thumb {
          background-color: #C0BEBE;  /* Scrollbar thumb color */
          border-radius: 4px;      /* Roundness of the scrollbar thumb */
      }
      
      /* Customize the scrollbar track */
      .breadcrumbs::-webkit-scrollbar-track {
          background-color: #F4F1EF;  /* Scrollbar track color */
          border-radius: 4px;

      }
      .breadcrumbs ol {
        list-style-type: none;
        margin: 0;
        padding: 0;
      }
      .breadcrumbs li { 
        display: inline-block;
      }
      .breadcrumbs .last-breadcrumb, .breadcrumbs span.last-link , .breadcrumbs span.br-last-link:not([aria-hidden="true"]){
        color: var(--Neutrals-Black, #000) !important;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
        flex-shrink:0;
      }
      .breadcrumbs a  {
        flex-shrink:0;
        position: relative;
        transition: 0.3s;
        color: var(--Neutrals-Black, #000) !important;
        font-family: Roboto;
        font-size: 16px !important;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
        text-decoration:none !important;
        padding:0 !important;
      }
      .breadcrumbs span{
        display:flex;
        flex-shrink:0;
      }
      .breadcrumbs a:before {
        display:none;
      }
     
      .breadcrumbs ol li:last-of-type {
        pointer-events: none;
      }
      .breadcrumbs ol li:after {
        display:none
      }
      .breadcrumbs [aria-current=page] {
        color: inherit;
        font-weight: initial;
        text-decoration: none;
      }
      .breadcrumbs [aria-current=page],
      .breadcrumbs [aria-current=page]:hover {
        text-decoration: none;
      }
      .breadcrumbs {
        text-align: center;
        text-transform: uppercase;
      }
      @media screen and (max-width: 550px) {
        .breadcrumbs a {
            font-size: 12px !important;
          }
      }
    `;
      if (document.querySelector(".main-product")) {
        document.querySelector("product-info").style.paddingTop = "0";
        closestAppSection.style.display = "block";
        closestAppSection.style.background = "#f8f8f8";

        style.innerHTML += `
        .breadcrumbs{
          padding: 48px 0 24px 0 !important;
        }
        @media screen and (max-width: 550px) {
          .breadcrumbs  {
              font-size: 12px !important;
              padding: 24px 0 16px 0 !important;
            }
        }`;
      } else {
        style.innerHTML += `
        .breadcrumbs{
          padding-block: 0 !important;
          padding-inline: 24px;
          font-size: 12px;
        }
            
        @media screen and (min-width: 1024px) {
          .breadcrumbs  {
              padding-inline: 0;
            }
        }`;
      }

      document.body.appendChild(style);
      if (navigation) {
        const spans = navigation.querySelectorAll(
          'span:empty, span[aria-hidden="true"]'
        );
        spans.forEach((span) => {
          span.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33377 4.5L0.000360489 1.16659L0.666948 0.5L4.33365 4.16671C4.42203 4.25511 4.47168 4.375 4.47168 4.5C4.47168 4.625 4.42203 4.74489 4.33365 4.83329L0.666948 8.5L0.000360489 7.83341L3.33377 4.5Z" fill="black"/>
          </svg>
            `;
        });

        spans[spans.length - 1].style.display = "none";
        if (navigation.querySelector(".last-link")) {
          navigation.querySelector(".last-link").style.display = "none";
        }

        spans[0].style.display = "none";
        navigation.querySelectorAll("a")[0].style.display = "none";
      }
      navigation.style.opacity = "1";
      const firstLinkInnerHTML = navigation.querySelectorAll("a")[1].innerHTML;
      if (window.innerWidth <= 750) {
        if (navigation.querySelectorAll("a").length > 3) {
          navigation.querySelectorAll("a")[1].innerHTML = "...";
        } else {
          navigation.querySelectorAll("a")[1].innerHTML = firstLinkInnerHTML;
        }
      }
      window.addEventListener("resize", () => {
        console.log(firstLinkInnerHTML);
        if (navigation.querySelectorAll("a").length > 3) {
          if (window.innerWidth <= 750) {
            navigation.querySelectorAll("a")[1].innerHTML = "...";
          } else {
            navigation.querySelectorAll("a")[1].innerHTML = firstLinkInnerHTML;
          }
        }
      });
    });
  }

  function initBreadcrumbs() {
    breadcrumbsUiHandling();
  }

  initBreadcrumbs();

  // Public API
  return {
    initBreadcrumbs,
  };
})();
